import { useContext } from 'react';
import { UIContext, UIContextProps } from '../context/UIContext';

export interface AppVariantProps extends Pick<UIContextProps, 'appVariant'> {
  isDispatcherPortal: boolean;
  isClientPortal: boolean;
  isCarrierPortal: boolean;
}

export const useAppVariant = (): AppVariantProps => {
  const { appVariant } = useContext(UIContext);
  return {
    appVariant,
    isDispatcherPortal: appVariant === 'dispatcher',
    isClientPortal: appVariant === 'client',
    isCarrierPortal: appVariant === 'carrier',
  };
};
